export const tokens = {
    offsetX: 8,
    fontSize: 14,
};
